import WixSDK from 'shared/utils/wix-sdk';
import { event as biEvent, error as biError, now, validateBiEventArgs, ErrorSeverity } from './bi-core';
import { attempt } from 'shared/utils/attempt';


const VOID_SRC_ID = 71;
const ADAPTER = 'video';


function getDefaultParams() {
  return {
    biToken: attempt(() => WixSDK.Utils.getInstanceValue('biToken')), // same as sid, but we use biToken everywhere
    videoInstanceID: attempt(() => WixSDK.Utils.getInstanceId()),
    visitorID: getVisitorId(),
  };
}

function getVisitorId() {
  return attempt(() => WixSDK.Utils.getInstanceValue('uid')) ||
    attempt(() => WixSDK.Utils.getInstanceValue('aid')) ||
    '';
}

function makeRestriction(fields) {
  return _.mapValues(fields, restriction => (_.isString(restriction) ? { type: restriction } : restriction));
}

function addDefaultParams(next) {
  return (eventDef, params) => {
    const defaultParams = getDefaultParams();
    const eventParams = _(eventDef.fields)
      .keys()
      .reduce((acc, name) => ({
        ...acc,
        [name]: _.isUndefined(params[name]) ? defaultParams[name] : params[name],
      }), {});
    return next(eventDef, eventParams);
  };
}

function validate(next) {
  return (eventDef, params) => {
    validateBiEventArgs(params, _.keys(eventDef.fields), makeRestriction(eventDef.fields), eventDef.id);
    return next(eventDef, params);
  };
}

function addObligatoryFields(next) {
  return (eventDef, params) => next(eventDef, {
    evid: eventDef.id,
    ...params,
    adapter: ADAPTER,
    src: VOID_SRC_ID,
    _: now(),
  });
}

let logEventEnabled = false;
function createLogger(type) {
  return function (next) {
    return function (eventDef, params) {
      return next(eventDef, params)
        .then(data => {
          if (logEventEnabled) {
            console.warn(`bi ${type}:`, eventDef.name, params); // eslint-disable-line no-console
          }
          return data;
        });
    };
  };
}

function formatEvent(next) {
  return (eventDef, params) =>
    next(params);
}

function createError(next) {
  return (eventData, params) =>
    next(eventData, {
      errc: eventData.id,
      errn: eventData.name,
      iss: params.iss,
      sev: params.severity || ErrorSeverity.ERROR,
      adapter: 'trg',
      src: VOID_SRC_ID,
      cat: 1,
      p1: eventData.service,
      p2: params.application,
    });
}

export const event = addDefaultParams(validate(addObligatoryFields(createLogger('event')(formatEvent(biEvent)))));
export const sendError = createError(createLogger('error')(formatEvent(biError)));

export function enableEventLogging() {
  logEventEnabled = true;
}



// WEBPACK FOOTER //
// ./src/shared/bi/bi-vod.js